import React from "react";
import { Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import { useTemplateFontSettings } from "styles/templateFontSettings";
import AddUpdateAnnouncementCard from "../Card/AddUpdateAnnouncementCard";

function AddUpdateAnnouncementDialog({ onClose, open, afterUpdateFunc, selectedAnnouncement, addAfterTable }) {
    
    return (
        <Dialog onClose={onClose} open={open} fullWidth maxWidth="lg">
            <DialogTitle>{selectedAnnouncement ? 'Duyuru Güncelle' : 'Duyuru Ekle'}</DialogTitle>
            <DialogContent dividers>
                <AddUpdateAnnouncementCard afterUpdateFunc={afterUpdateFunc} selectedAnnouncement={selectedAnnouncement} onClose={onClose} addAfterTable={addAfterTable} />
            </DialogContent>
            <DialogActions>
            </DialogActions>
        </Dialog>
    );
}

export default AddUpdateAnnouncementDialog